/** OAuth providers the app can sign in with */
export const OAUTH_PROVIDERS = ['google', 'microsoft'] as const

export type OAuthProvider = (typeof OAUTH_PROVIDERS)[number]
